/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsCustomerBusinessAreaLeadTemplateData } from '../../models/mail-params-customer-business-area-lead-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendCustomerBusinessAreaLeadMail$Params {
      body: MailParamsCustomerBusinessAreaLeadTemplateData
}

export function sendCustomerBusinessAreaLeadMail(http: HttpClient, rootUrl: string, params: SendCustomerBusinessAreaLeadMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendCustomerBusinessAreaLeadMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendCustomerBusinessAreaLeadMail.PATH = '/sendMail/customer-businessarea-lead';
